import React, { PureComponent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Styles from './ExperienceArticle.styles';
import ExperiencePost from '../../base/ExperiencePost';
import { getKey } from '../../../helpers';
import translationsOptions from './data/translations';

const Wrapper = styled.div`${Styles.wrapper}`;

/**
 * Experiencearticle componente
 */
class ExperienceArticle extends PureComponent {
  static propTypes = {
    locale: PropTypes.string,
    title: PropTypes.string,
    date: PropTypes.string,
    review: PropTypes.string,
    content: PropTypes.string,
    tags: PropTypes.array,
    image: PropTypes.object,
    url: PropTypes.string,
  }

  /**
   * Constructor method
   * @param {Object} props of the component
   */
  constructor(props) {
    super(props);
    this.state = {
      translations: getKey(translationsOptions, props.locale),
    };
  }

  /**
   * render method
   * @returns {JSX}
   */
  render() {
    const {
      title,
      date,
      review,
      locale,
      image,
      content,
      tags,
      url
    } = this.props;

    const { translations: { backtext } } = this.state;
    return (
      <Wrapper className="container">
        <ExperiencePost
          title={title}
          tags={tags}
          review={review}
          locale={locale}
          backtext={backtext}
          content={content}
          image={image}
          url={url}
          date={date}
        />
      </Wrapper>
    );
  }
}

export default ExperienceArticle;
